import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../utilities/TabUtilities";
import LSService from "../../../../utilities/localStorageService/LSService";
import ReactTooltip from "react-tooltip";
import {ControlLabel} from "react-bootstrap";

export default class DostepTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.formatTypId = this.formatTypId.bind(this)
        this.onClickTypId = this.onClickTypId.bind(this)
        this.formatDaneOsoby = this.formatDaneOsoby.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction buttonIcon={'fa fa-key'} onClick={() => {
                    this.props.handleZmienHaslo(row)
                }} titleContent={'Zmień hasło dostępu'}/>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj dostęp'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń dostęp'}/>
            </div>
        )
    }

    formatRole(cell, row) {
        if (Boolean(cell)) {
            return row.role.map(item => {
                return item.rola+' '
            })
        }
    }

    formatZablokowany(cell, row) {
        if (cell) return 'tak'
        else return 'nie'
    }

    formatTypId(cell, row) {
        if (Boolean(cell)) {
            return <div title={'Kliknij aby wyszukać'}
                        style={{cursor: 'pointer'}}
                        onClick={() => this.onClickTypId(cell, row.typ)}>
                    <span className={'label label-ebus-primary'}>
                           {cell}
                    </span>
            </div>
        }
    }

    onClickTypId(id, typ) {
        if (typ === 'KLIENT') {
            this.props.history.push('/zarzadzanie-klientami/klient/'+id)
        }
        else if (typ === 'KIEROWCA') {
            LSService.ustawIdKierowcyDoFiltrowania(id)
            this.props.history.push('/konfiguracja/zarzadzanie-zasobami/kierowcy')
        }
        else if (typ === 'PRACOWNIK') {
            LSService.ustawIdPracownikaDoFiltrowania(id)
            this.props.history.push('/administracja/pracownicy')
        }
    }

    formatDaneOsoby(cell, row) {
        if (row.typ === 'KLIENT') {
            return cell

        }
        else if (row.typ === 'KIEROWCA') {
            let kierowca = this.props.kierowcy.find(k => k.typId === row.typId)
            if (Boolean(kierowca))
                return this.renderKierowca(kierowca, cell)
            else return cell
        }
        else if (row.typ === 'PRACOWNIK') {
            let pracownik = this.props.pracownicy.find(p => p.typId === row.typId)
            if (Boolean(pracownik))
                return this.renderPracownik(pracownik, cell)
            else return cell
        }
    }

    renderKierowca(kierowca, login) {
        if (Boolean(kierowca)) {
            return (
                <div>
                    <div data-tip='' data-for={'kierowca_data' + kierowca.idPr + '-' + login} data-place="right" className='tooltip_here'
                         style={{cursor: 'pointer', color: '#2780e3', textDecoration: 'underline'}}>
                        {login}
                    </div>
                    <ReactTooltip id={'kierowca_data' + kierowca.idPr + '-' + login}>
                        <div>
                            {
                                Boolean(kierowca.imie) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-user'
                                                                        style={{marginRight: '5px'}}></i> {kierowca.imie + ' ' + kierowca.nazwisko}
                                    </div> : ''
                            }
                            {
                                Boolean(kierowca.pesel) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-id-card-o'
                                                                        style={{marginRight: '5px'}}></i>Pesel: {kierowca.pesel}
                                    </div> : ''
                            }
                            {
                                Boolean(kierowca.nrTel) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-phone'
                                                                        style={{marginRight: '5px'}}></i>Telefon: {kierowca.nrTel}
                                    </div> : ''
                            }
                            {
                                Boolean(kierowca.email) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-envelope'
                                                                        style={{marginRight: '5px'}}></i>Email: {kierowca.email}
                                    </div> : ''
                            }
                            {
                                Boolean(kierowca.stanowisko) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-id-badge'
                                                                        style={{marginRight: '5px'}}></i>Stanowisko: {kierowca.stanowisko}
                                    </div> : ''
                            }
                        </div>
                    </ReactTooltip>
                </div>
            )
        }
    }

    renderPracownik(pracownik, login) {
        if (Boolean(pracownik)) {
            return (
                <div>
                    <div data-tip='' data-for={'pracownik_data' + pracownik.idPr + '-' + login} data-place="right" className='tooltip_here'
                         style={{cursor: 'pointer', color: '#2780e3', textDecoration: 'underline'}}>
                        {login}
                    </div>
                    <ReactTooltip id={'pracownik_data' + pracownik.idPr + '-' + login}>
                        <div>
                            {
                                Boolean(pracownik.imie) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-user'
                                                                        style={{marginRight: '5px'}}></i> {pracownik.imie + ' ' + pracownik.nazwisko}
                                    </div> : ''
                            }
                            {
                                Boolean(pracownik.email) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-envelope'
                                                                        style={{marginRight: '5px'}}></i>Email: {pracownik.email}
                                    </div> : ''
                            }
                        </div>
                    </ReactTooltip>
                </div>
            )
        }
    }

    render() {

        const options = {
            sizePerPageList: [10, 15, 30, 50, 100],
            noDataText: 'Brak pasujących rekordów',
            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };

        return (
            <div>
                <div className={'pull-right'} style={{marginTop: '15px'}}>
                    <ControlLabel>Ilość rekordów: {this.props.pageable.totalElements}</ControlLabel>
                </div>
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                hover
                                fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                remote={true}
                                pagination={true}
                >
                    <TableHeaderColumn dataField='idUz' isKey hidden={false}
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                    >ID UZ</TableHeaderColumn>
                    <TableHeaderColumn dataField='login'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       dataFormat={this.formatDaneOsoby}
                    >Login</TableHeaderColumn>
                    <TableHeaderColumn dataField='typ'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                    >Typ</TableHeaderColumn>
                    <TableHeaderColumn dataField='typId'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.formatTypId}
                    >TypID</TableHeaderColumn>
                    <TableHeaderColumn dataField='roleString'
                                       thStyle={tabgrid.tg9} tdStyle={tabgrid.tg9}
                                       dataFormat={this.formatRole}
                    >Role (Uprawniony do:)</TableHeaderColumn>
                    <TableHeaderColumn dataField='zablokowany'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.formatZablokowany}
                    >Zablokowany?</TableHeaderColumn>
                    <TableHeaderColumn dataField='idUz'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Zmień hasło', '#333333')}</TableHeaderColumn>

                </BootstrapTable>
            </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/dostep/components/DostepTable.js